import { render, staticRenderFns } from "./CreateUpdateSerpPopup.vue?vue&type=template&id=99c71456"
import script from "./CreateUpdateSerpPopup.vue?vue&type=script&lang=js"
export * from "./CreateUpdateSerpPopup.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateSerpPopup.vue?vue&type=style&index=0&id=99c71456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports